import { client } from './api';

class LotService {
  getAllLots = itemsPerPage => client.get(`Lot?${itemsPerPage}`);

  addToFavorite = async lotId => {
    const response = await client.post(`favorite/${lotId}`);
    return response;
  };

  removeFromFavorite = async lotId => {
    const response = await client.delete(`favorite/${lotId}`);
    return response;
  };

  searchLots = urlParams => client.get(`Lot/search?${urlParams}`);

  getSingleLot = (lotId, currency) => {
    let qdata = lotId;
    if (currency) qdata += '?currency=' + currency;
    return client.get('Lot/' + qdata);
  };

  createLot = Lot => client.post('Lot', Lot, { headers: { 'content-type': 'multipart/form-data' } });

  editLot = (lotId, Lot) => client.put(`Lot/${lotId}`, Lot, { headers: { 'content-type': 'multipart/form-data' } });

  activate = lotId => client.post(`Lot/${lotId}/activate`);

  deactivate = lotId => client.post(`Lot/${lotId}/deactivate`);

  delete = lotId => client.delete(`Lot/${lotId}`);
}
export default LotService;
